import React, { Component } from 'react'
import "../css/email-subscribe.css"

import { PRINT_RECORD_SHARING_STATUS } from "../containers/account-setting-container";


class PrintRecordSharing extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className='upper-section-container'>
                <div className='upper-section-title upper-section-subtitle'>
                    SprintRay Customer Support Visibility
                <div className={`toggle-background ${this.props.printRecordSharingToggleable ? '' : 'toggle-disable'}`}
                        onClick={this.props.togglePrintRecordSharing}>
                        <div
                            className={this.props.currentStatus === PRINT_RECORD_SHARING_STATUS.ON ? 'toggle-content toggle-content-active' : 'toggle-content'}>On
                    </div>
                        <div
                            className={this.props.currentStatus === PRINT_RECORD_SHARING_STATUS.OFF ? 'toggle-content toggle-content-active' : 'toggle-content'}>Off
                    </div>
                    </div>
                </div>
                <div className='upper-section-introduce'>
                    Turn this feature on when talking to SprintRay customer service team to give them visibility over the print status and report. This feature is off by default to protect your privacy.
                </div>
            </div>
        );
    }
}

export default PrintRecordSharing


// WEBPACK FOOTER //
// ./src/containers/print_record_sharing.js